theme.headerSection = (function () {
  function header() {
    /* Mobile Menu Function */
    const MobileMenu = function () {
      const offcanvasOpen = document.querySelector(
          ".header__actions_btn--menu"
        ),
        offcanvasClose = document.querySelector(".offcanvas__close_btn"),
        offcanvasHeader = document.querySelector(".offcanvas-header"),
        offcanvasMenuAll = document.querySelectorAll(".offcanvas__menu"),
        body = document.querySelector("body");

      if (!offcanvasOpen || !offcanvasClose || !offcanvasHeader) return;
      let previousOverflow = null;
      function closeMenu(restoreFocus = false) {
        if (!offcanvasHeader.classList.contains("open")) return;
        offcanvasHeader.classList.remove("open");
        offcanvasHeader.inert = true;
        offcanvasOpen.setAttribute("aria-expanded", "false");
        body.style.overflowY = previousOverflow;
        if (restoreFocus) offcanvasOpen.focus();
      }
      offcanvasOpen.addEventListener("click", function (e) {
        e.preventDefault();
        previousOverflow = body.style.overflowY;
        offcanvasHeader.inert = false;
        offcanvasHeader.classList.add("open");
        offcanvasOpen.setAttribute("aria-expanded", "true");
        body.style.overflowY = "hidden";
        requestAnimationFrame(() => offcanvasClose.focus());
      });
      offcanvasHeader.addEventListener("transitionend", function (e) {
        if (e.target === offcanvasHeader && e.propertyName === "transform" &&
            offcanvasHeader.classList.contains("open") && document.activeElement === offcanvasOpen) {
          offcanvasClose.focus();
        }
      });
      offcanvasClose.addEventListener("click", function (e) {
        e.preventDefault();
        closeMenu(true);
      });
      offcanvasHeader.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
          e.preventDefault();
          closeMenu(true);
        } else if (e.key === "Tab") {
          const focusable = Array.from(offcanvasHeader.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex="0"]'
          )).filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== "hidden");
          const first = focusable[0], last = focusable[focusable.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault(); last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault(); first.focus();
          }
        }
      });
      /* Open/Close Sub Menu On Click Toggle Button */

      if (offcanvasMenuAll.length > 0) {
        offcanvasMenuAll.forEach((offcanvasMenu) => {
          /* Add a Button For SubMenu Toggle */
          offcanvasMenu
            .querySelectorAll(".offcanvas__sub_menu")
            .forEach(function (ul) {
              const subMenuToggle = document.createElement("button");
              subMenuToggle.classList.add("offcanvas__sub_menu_toggle");
              subMenuToggle.type = "button";
              subMenuToggle.setAttribute("aria-label", ul.previousElementSibling.textContent.trim());
              subMenuToggle.setAttribute("aria-expanded", "false");
              ul.parentNode.appendChild(subMenuToggle);
            });

          /* Submenu toggle */
          offcanvasMenu
            .querySelectorAll(".offcanvas__sub_menu_toggle")
            .forEach(function (toggle) {
              toggle.addEventListener("click", function (e) {
                e.preventDefault();
                const parent = this.parentElement;
                if (parent.classList.contains("active")) {
                  this.classList.remove("active");
                  this.setAttribute("aria-expanded", "false");
                  parent.classList.remove("active");
                  parent
                    .querySelectorAll(".offcanvas__sub_menu")
                    .forEach(function (subMenu) {
                      subMenu.parentElement.classList.remove("active");
                      subMenu.nextElementSibling.classList.remove("active");
                      subMenu.nextElementSibling.setAttribute("aria-expanded", "false");
                      slideUp(subMenu);
                    });
                } else {
                  this.classList.add("active");
                  this.setAttribute("aria-expanded", "true");
                  parent.classList.add("active");
                  slideDown(this.previousElementSibling);
                  getSiblings(parent).forEach(function (item) {
                    item.classList.remove("active");
                    item
                      .querySelectorAll(".offcanvas__sub_menu")
                      .forEach(function (subMenu) {
                        subMenu.parentElement.classList.remove("active");
                        subMenu.nextElementSibling.classList.remove("active");
                      subMenu.nextElementSibling.setAttribute("aria-expanded", "false");
                        slideUp(subMenu);
                      });
                  });
                }
              });
            });
        });
      }

      document.addEventListener("click", function (event) {
        if (
          !event.target.closest(".header__actions_btn--menu") &&
          !event.target.classList.contains(
            ".header__actions_btn--menu".replace(/\./, "")
          )
        ) {
          if (
            !event.target.closest(".offcanvas-header") &&
            !event.target.classList.contains(
              ".offcanvas-header".replace(/\./, "")
            )
          ) {
            closeMenu(offcanvasHeader.contains(document.activeElement));
          }
        }
      });

      /* Remove Mobile Menu Open Class & Hide Mobile Menu When Window Width in More Than 991 */
      window.addEventListener("resize", function () {
        if (window.innerWidth >= 992) closeMenu();
      });
    };
    /* Mobile Menu Active */
    MobileMenu();

    /* Menu toggle buttons */
    const mobileMenuToggleButtons = document.querySelectorAll(
      ".mobile--menu-header-button"
    );
    const mobileMainMenu = document.querySelector(".mobile__main-menu--list");
    const mobileVerticalMenu = document.querySelector(
      ".mobile__categories--list"
    );
    if (mobileMenuToggleButtons.length > 0) {
      mobileMenuToggleButtons.forEach((button) => {
        button?.addEventListener("click", function (e) {
          mobileMenuToggleButtons.forEach((childButton) => {
            childButton.classList.remove("active");
          });
          if (button.classList.contains("mobile__main--menu")) {
            button.classList.add("active");
            if (mobileMainMenu.classList.contains("d-none")) {
              mobileMainMenu.classList.remove("d-none");
            }
            mobileVerticalMenu.classList.add("d-none");
          }
          if (button.classList.contains("mobile__categories--menu")) {
            button.classList.add("active");
            if (mobileVerticalMenu.classList.contains("d-none")) {
              mobileVerticalMenu.classList.remove("d-none");
            }
            mobileMainMenu.classList.add("d-none");
          }
        });
      });
    }
  }

  return header;
})();
